import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface NetworkRequest {
  id: string;
  url: string;
  method: string;
  status?: number;
  timestamp: string;
  duration?: number;
  error?: string;
  responseBody?: string;
  requestHeaders?: Record<string, string>;
}

interface NetworkState {
  requests: NetworkRequest[];
  maxRequests: number;
}

const initialState: NetworkState = {
  requests: [],
  maxRequests: 200,
};

const networkSlice = createSlice({
  name: 'network',
  initialState,
  reducers: {
    addNetworkRequest: (state, action: PayloadAction<Omit<NetworkRequest, 'timestamp'> & { id?: string }>) => {
      const { id, ...payload } = action.payload;
      const newRequest: NetworkRequest = {
        id: id || Date.now() + Math.random().toString(),
        timestamp: new Date().toISOString(),
        ...payload,
      };
      
      state.requests.unshift(newRequest);
      
      if (state.requests.length > state.maxRequests) {
        state.requests = state.requests.slice(0, state.maxRequests);
      }
    },
    updateNetworkRequest: (state, action: PayloadAction<{ id: string; updates: Partial<NetworkRequest> }>) => {
      const index = state.requests.findIndex(req => req.id === action.payload.id);
      if (index !== -1) {
        state.requests[index] = { ...state.requests[index], ...action.payload.updates };
      }
    },
    clearNetworkRequests: (state) => {
      state.requests = [];
    },
  },
});

export const { addNetworkRequest, updateNetworkRequest, clearNetworkRequests } = networkSlice.actions;

export const getNetworkRequests = (state: RootState) => state.network.requests;

export default networkSlice.reducer; 